
import { Component, Prop, PropSync, Vue } from 'nuxt-property-decorator'
import { Provider } from '~/core/offer.types'
import { OnMounted } from '~/core/vue.types'

@Component
export default class ProvidersFilter extends Vue implements OnMounted {
  @Prop({ required: true, default: () => [], type: Array })
  readonly providers!: number|string[]

  @Prop({ required: false, default: () => [], type: Array })
  readonly availableProvidersList!: number[]

  @Prop({ required: false, default: false, type: Boolean })
  readonly isGrid!: boolean

  @Prop({ required: false, default: () => [], type: Array })
  readonly providersList!: Provider[]

  @PropSync('providers', { type: Array })
  selectedProviders!: string|number[]

  private isShowAllProviders = false
  private isMounted = false

  get randomId () {
    return 1 + Math.floor((9999999 - 1) * Math.random())
  }

  get filterProviders () {
    if (!this.providersList.length) {
      return []
    }

    const providers = this.providersList.filter((item: any) => this.isProviderAvailable(item.pk))
    return this.isShowAllProviders
      ? providers
      : providers.slice(0, 6)
  }

  get providersQuantity () {
    return this.availableProvidersList.length ? this.availableProvidersList.length : this.providersList.length
  }

  isProviderAvailable (pk: number) {
    return this.availableProvidersList.length
      ? this.availableProvidersList.includes(pk)
      : true
  }

  selectAll () {
    const providersListPKs = this.providersList.map(p => p.pk)

    this.selectedProviders =
      this.availableProvidersList.length
        ? providersListPKs.filter(pk => this.availableProvidersList.includes(pk))
        : providersListPKs

    this.isShowAllProviders = true
  }

  clearAll () {
    this.selectedProviders = []
  }

  toggleProvidersVisibility () {
    this.isShowAllProviders = !this.isShowAllProviders
  }

  mounted () {
    this.isMounted = true
  }
}
